import React from "react";
import { useNavigate } from "react-router-dom";
import {
  IoMenuOutline,
  IoPeopleOutline,
  IoShieldCheckmarkOutline,
  IoSettingsOutline,
  IoTrashOutline,
  IoLogOutOutline,
  IoDocumentTextOutline,
} from "react-icons/io5";
import { HiOutlineLink } from "react-icons/hi2";

export default function WorkspaceOffcanvas({
  showOffcanvas,
  activeView,
  isOwner,
  isAdmin,
  hasPermission,
  onSelectView,
  onClose,
  onLeave,
  onDeleteWorkspace,
  offcanvasRef,
}) {
  const navigate = useNavigate();

  const handleClick = (view) => {
    onSelectView(view);
    onClose();
  };

  return (
    <>
      {showOffcanvas && <div className="offcanvas-backdrop fade show" />}
      <div
        ref={offcanvasRef}
        className={`offcanvas ${showOffcanvas ? "show" : ""}`}
        tabIndex="-1"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1055,
          width: "320px",
          height: "100dvh",
          visibility: showOffcanvas ? "visible" : "hidden",
          transform: showOffcanvas ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out",
          backgroundColor: "var(--bs-body-bg, #fff)",
          borderRight: "1px solid var(--bs-border-color, #dee2e6)",
        }}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title">Actions</h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body p-0">
          <div className="list-group list-group-flush">
            <button
              className={`list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 ${activeView === "invitation" ? "active" : ""}`}
              onClick={() => handleClick("invitation")}
            >
              <HiOutlineLink size={20} />
              <div>
                <strong>Inviter des membres</strong>
                <br />
                <small className="text-muted">Générer un code d'invitation</small>
              </div>
            </button>

            {isAdmin && (
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 ${activeView === "members" ? "active" : ""}`}
                onClick={() => handleClick("members")}
              >
                <IoPeopleOutline size={20} />
                <div>
                  <strong>Gérer les membres</strong>
                  <br />
                  <small className="text-muted">Ajouter ou retirer des membres</small>
                </div>
              </button>
            )}

            {isAdmin && (
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 ${activeView === "permissionsList" ? "active" : ""}`}
                onClick={() => handleClick("permissionsList")}
              >
                <IoShieldCheckmarkOutline size={20} />
                <div>
                  <strong>Rôles et permissions</strong>
                  <br />
                  <small className="text-muted">Gérer les rôles et droits des membres</small>
                </div>
              </button>
            )}

            {hasPermission("MANAGE_FILES") && (
              <button
                className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
                onClick={() => {
                  onClose();
                  navigate("/workspace/pelagie/fichiers");
                }}
              >
                <IoDocumentTextOutline size={20} />
                <div>
                  <strong>Base de connaissances de Pélagie</strong>
                  <br />
                  <small className="text-muted">Gérer les documents</small>
                </div>
              </button>
            )}

            {isOwner && (
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 ${activeView === "general" ? "active" : ""}`}
                onClick={() => handleClick("general")}
              >
                <IoSettingsOutline size={20} />
                <div>
                  <strong>Paramètres généraux</strong>
                  <br />
                  <small className="text-muted">Modifier le nom, la description, l'image</small>
                </div>
              </button>
            )}

            <hr className="my-1" />

            <button
              className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 text-danger"
              onClick={() => {
                if (window.confirm("Quitter cet espace ?")) {
                  onClose();
                  onLeave();
                }
              }}
            >
              <IoLogOutOutline size={20} />
              <div>
                <strong>Quitter l'espace</strong>
                <br />
                <small className="text-muted">Vous ne ferez plus partie de cet espace</small>
              </div>
            </button>

            {isOwner && (
              <button
                className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 text-danger"
                onClick={() => {
                  if (
                    window.confirm(
                      "Supprimer définitivement cet espace ? Cette action est irréversible."
                    )
                  ) {
                    onClose();
                    onDeleteWorkspace();
                  }
                }}
              >
                <IoTrashOutline size={20} />
                <div>
                  <strong>Supprimer l'espace</strong>
                  <br />
                  <small className="text-muted">Suppression définitive (propriétaire uniquement)</small>
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
